import React, { useEffect, useState } from "react";
import BestSellings from "./BestSellings";
import { useNavigate } from "react-router-dom";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { useLanguage } from "../../context/LanguageContext";

interface IProps {
  categoriesData: any;
  setCategoryModal: any;
  setSelectedCategory: any;
  selectedCategory: any;
}

const CategoriesModal: React.FC<IProps> = ({
  categoriesData,
  setCategoryModal,
  setSelectedCategory,
  selectedCategory,
}) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const {t} = useLanguage();

  const handleClickSubCategory = (sub: any) => {
    setCategoryModal(false);
    setSelectedCategory(null);
    navigate(`/product-categories/${sub?.id}?subCatName=${sub?.name}`);
  };

  useEffect(() => {
    const getCategoryProducts = async () => {
      try {
        const response = await getFetcher(
          endpoints.products.getProductsByMainCategory.replace(
            "{id}",
            selectedCategory?.id || ""
          )
        );
        setProducts(response?.products);
      } catch (error) {
        console.log(error);
      }
    };
    getCategoryProducts();
  }, [selectedCategory]);


  const handleClickMainCategory = (main: any) => {
    navigate(`/product-categories/${main?.id}?main=${main?.name}`)
    setCategoryModal(false);
  }


  return (
    <div className=" flex gap-x-20 bg-[#FFFFFF] p-1 justify-center ">
      <div className=" flex flex-col gap-y-2 px-10 py-4 min-w-[300px]">
        {/* title */}
        <div onClick={() => handleClickMainCategory(categoriesData)} className=" flex font-bold  gap-x-1 text-primary-color  text-2xl  hover:text-yellow-color hover:underline hover:cursor-pointer transition-all ">
          <p  className="">{categoriesData?.name}</p>
          <p>{t('navbar', 'cat')}</p>
        </div>

        {/* categories */}
        {/* <div className=" ml-5">
          {[1,2,3,4,5,6,7,8,9,10].map((sub: any) => {
            return (
              <ul className=" list-disc" >
                <li
                  onClick={() => handleClickSubCategory(sub)}
                  className=" cursor-pointer text-xs font-semibold hover:underline  transition-all text-[#141C3A] list-item "
                >
                  {'sub?.name'}
                </li>
              </ul>
            );
          })}
        </div> */}
        <div className="ml-5 grid grid-cols-2 gap-x-32">
          {categoriesData?.subCategories?.map((sub: any, index: any) => (
            <ul key={index} className="list-disc">
              <li
                onClick={() => handleClickSubCategory(sub)}
                className="cursor-pointer text-[18px] font-poppins font-normal transform  duration-300 hover:underline text-primary-color list-item py-1 min-w-[220px] hover:text-yellow-color"
              >
                {sub?.name}
              </li>
            </ul>
          ))}
        </div>
      </div>

      <div className=" border-r-[1px] text-[#D2D2D2]"></div>

      <div className=" flex flex-col gap-y-2 px-10 py-4 min-w-[300px] -ml-14">
        {/* title */}
        <div className=" flex font-bold text-2xl font-poppins text-primary-color">
          <p>{t("navbar", "bestSall")}</p>
        </div>

        <div className=" w-full h-full flex items-center">
          <BestSellings products={products}/>
        </div>
      </div>
    </div>
  );
};

export default CategoriesModal;
